'use strict';exports.__esModule = true;exports.configMainHeaderRow = exports.configAdditionalHeaderRow = undefined;var _constants = require('../../constants');

var mainHeaderLinkIdPrefix = 'headerMainLink_';
var additionalHeaderLinkIdPrefix = 'headerAdditionalLink_';

var createMainLinkId = function createMainLinkId(id) {return '' + mainHeaderLinkIdPrefix + id;};
var createAdditionalLinkId = function createAdditionalLinkId(id) {return '' + additionalHeaderLinkIdPrefix + id;};

var configAdditionalHeaderRow = exports.configAdditionalHeaderRow = function configAdditionalHeaderRow(translate) {return [
  { id: createAdditionalLinkId('help'), link: '/help', name: translate('header', 'help').toString() },
  { id: createAdditionalLinkId('professionals'), link: '/professionals', name: translate('header', 'professionals').toString() },
  { id: createAdditionalLinkId('articles'), link: '/articles', name: translate('header', 'articles').toString() },
  { id: createAdditionalLinkId('virtualTour'), link: '/vr_promotion', name: translate('header', 'vrPromotion').toString() },
  { id: createAdditionalLinkId('realtorContactUs'), link: '/contact_us_realtor', name: translate('footer', 'realtorContactUs').toString() }];};


var configMainHeaderRow = exports.configMainHeaderRow = function configMainHeaderRow(translate) {return [
  {
    id: createMainLinkId('forSale'),
    location: _constants.sections.homes.location,
    option: _constants.optionTypes.buy,
    name: translate('header', 'buy').toString(),
    main: 'buy' },

  {
    id: createMainLinkId('forRent'),
    location: _constants.sections.homes.location,
    option: _constants.optionTypes.rent,
    name: translate('header', 'rent').toString(),
    main: 'rent' },

  {
    id: createMainLinkId('commercial'),
    location: _constants.sections.commercial.location,
    option: _constants.optionTypes.buy,
    name: translate('header', 'commercial').toString(),
    main: 'commercial',
    options: { params: { rooms: [], types: [], price: {} } } },

  {
    id: createMainLinkId('projects'),
    location: 'projects',
    option: null,
    name: translate('header', 'projects').toString(),
    main: 'projects',
    options: { params: { rooms: [], types: [], price: {} } } },

  {
    id: createMainLinkId(_constants.ROUTES_PATHS.FOREIGN),
    location: _constants.ROUTES_PATHS.FOREIGN,
    option: null,
    name: translate('header', 'foreign').toString(),
    main: 'foreign',
    options: { params: { rooms: [], types: [], price: {} } },
    isNew: true }];};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderDesktop/config.js
// module id = 2674
// module chunks = 0